import React from "react"
import { Link } from "gatsby"

import AffirmIcon from "../../icons/affirm.svg"
import useThemeOptions from "../../hooks/useThemeOptions"

const PaybrightFinancing = () => {
  const {
    Options: {
      productSettings: { paybrightFinancingLink },
    },
  } = useThemeOptions()

  return (
    <div className="my-2 flex h-[22px] items-center text-body2">
      Finance with <AffirmIcon className="mb-[13px] h-[25px] w-[83px]" /> at
      check out.
      <Link
        className="link ml-2"
        to={paybrightFinancingLink?.url || "/financing"}
      >
        MORE INFO
      </Link>
    </div>
  )
}

export default PaybrightFinancing
